import { Suspense } from 'react';
import Loader from 'components/elements/Loader';

const withSuspense =
  (Component, fallback = <Loader />) =>
  props => (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );

export default withSuspense;
